module.exports = __webpack_public_path__ + "img/icon_xiaoqu.de3d527d.svg";